//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

import { makeStyles } from "@material-ui/core/styles";

export const consentStyles = makeStyles((theme) => ({
  divText: {
    fontSize: 30,
    fontFamily: "segoe-ui!important",
    textAlign: "center",
    backgroundColor: "#dddddd",
  },
  formtxt: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '26%'

  },
  formError: {
    backgroundColor: '#ffd6d6',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '26%',
    marginLeft: '9px'

  },
  formError1: {
    backgroundColor: '#ffd6d6',
    borderRadius: '5px 0px 0px 5px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '26%'
  },
  textField: {
    backgroundColor: 'white !important',
    borderRadius: '11px',
    height: '44px'

  },
  formError2: {
    backgroundColor: '#ffd6d6',
    borderRadius: '0px 5px 5px 0px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '26%'
  },
  formRadioError: {
    backgroundColor: '#ffd6d6',
    borderRadius: '5px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%',

  },

  formbtn: {
    display: 'flex',
    flexDirection: 'column',
    width: '10%',
    margin: 'auto'
  },
  horizondal: {

    borderLeft: '700px solid black',
    marginLeft: '-40px',
    opacity: '0.1'

  },
  errorTxt: {
    display: 'flex',
    backgroundColor: '#f23a3c',
    width: 'fit-content',
    height: '24px',
    color: 'white',
    marginTop: '5px',
    borderRadius: '3px',


  },
  formtxtRadio: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '100%'

  },
  formtxt1: {
    marginTop: '30px'

  },
  formtxt2: {
    marginTop: '30px',
    width: '100%'

  },
  backbtn: {
    backgroundColor: '#ECEDF3',
    color: 'black',
    fontWeight: 'normal',
    fontSize: '16px',
    fontFamily: '"Inter", sans-serif',
    width: '100px'

  },
  nextbtn: {
    backgroundColor: '#2e69ff',
    color: 'white',
    fontWeight: 'normal',
    fontSize: '16px',
    fontFamily: '"Inter", sans-serif',
    width: '100px'
  },
  formtxtTop: {
    // marginLeft:'200px',
    alignItems: "center",
    justifyContent: "space-between",


  },

  labelTxt: {
    color: '#060606',
    fontFamily: 'Inter, sans-serif',
    fontWeight: 500,
    fontSize: '.95em',
    marginBottom: 10
  },




  divSubText: {
    fontSize: 16,
    fontFamily: "segoe-ui!important",
    textAlign: "left",
    padding: 20,
  },
  card: {
    marginLeft: "auto",
    marginRight: "auto",
    width: "75%",
    marginBottom: 20,
    paddingBottom: 10,
  },
  cancelBtn: {
    float: "left",
    color: "rgb(55 126 185)",
    backgroundColor: "#dddddd",
    fontWeight: "bold",
    margin: 10,
    "&:hover": {
      backgroundColor: "#dddddd",
    },
  },
  enrollBtn: {
    float: "right",
    color: "#fff",
    backgroundColor: "#4472c4",
    fontWeight: "bold",
    margin: 10,
    "&:hover": {
      backgroundColor: "#4472c4",
    },
  },
  mainDiv: {
    textAlign: "center",
    padding: "10px 24px 10px 24px",
  },
  message: {
    fontSize: 20,
    fontFamily: "segoe-ui!important",
    padding: "20px 0px",
    width: "75%",
    margin: "0 auto",
  },
  goBackBtn: {
    color: "#fff",
    backgroundColor: "#4472c4",
    fontWeight: "bold",
    "&:hover": {
      backgroundColor: "#4472c4",
    },
  },
  manualMessage: {
    fontSize: 20,
    fontFamily: "segoe-ui!important",
    padding: "20px 0px",
    width: "75%",
    margin: "0 auto",
  },

  // header styles
  backtoHendry: {
    textAlign: "center",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "bold",
    lineHeight: 1.3,
    width: 70,
    "@media (max-width: 768px)": {
      fontSize: 12,
    },
  },
  logoImgDiv: {
    marginLeft: "10px",
    marginTop: 5,
  },
  logoImg: {
    width: "30%",
    display: 'block',
    backgroundColor: "#fff",
    "@media (max-width: 768px)": {
      width: 150,
    },
  },
  globeIconBtn: {
    padding: "0px 15px",
  },
  languageIcon: {
    color: "#4472c4",
    fontWeight: "bold",
    marginTop: 3,
    marginLeft: 5,
    "@media (max-width: 768px)": {
      fontSize: "30px",
      marginLeft: 0,
    },
  },
  flexGrid: {
    flex: 1,
    display: "inline-block",
    float: "right",
  },
  backToGrid: {
    display: "inline-block",
    verticalAlign: "top",
    float: "right",
    "@media (max-width: 768px)": {
      width: 75,
    },
  },
  flexBoxDiv: {
    // only for IE 9 or IE 11 browsers.
    marginRight: 10,
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)":
    {
      marginLeft: "10%",
    },
  },
  gridContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#fff",
    padding: 5,
    "@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none)":
    {
      justifyContent: "flex-start",
    },
  },

  // banner style
  HSBanner: {
    margin: "10px 0 0 0",
    "@media (max-width: 768px)": {
      display: "none",
    },
  },
  // Admin consent styles
  viewMyDashboardBtn: {
    textTransform: "capitalize",
    backgroundColor: "#5b9bd5",
    fontSize: 18,
    fontWeight: 700,
    color: "#fff",
    border: "1px solid #000",
    lineHeight: "normal",
    width: "15%",
    "&:hover": {
      backgroundColor: "#5b9bd5",
    },
  },
  consentBtnDiv: {
    textAlign: "center",
    marginTop: 15,
  },
  consentBtn: {
    backgroundColor: "#4472c4",
    fontWeight: "bold",
    textTransform: "none",
    width: "25%",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#4472c4",
    },
  },
  uploadConsentBtn: {
    backgroundColor: "#4472c4",
    textTransform: "none",
    borderRadius: '20px',
    width: "15%",
    color: "#fff",
    margin: 10,
    "&:hover": {
      backgroundColor: "#4472c4",
    },
  },
  comp: {
    textAlign: 'center',
    fontWeight: 300,
    fontSize: '2vw',
    color: '#005186',
    fontFamily: 'roboto, sans-serif'

  },
  text: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '2em',
    color: '#2c3345',
    fontFamily: 'Inter", sans-serif'

  },
  imgtier: {
    textAlign: 'center',
    marginTop: '51px',
  },
  sel: {
    fontWeight: 500,
    fontSize: '1.70em',
    marginTop: '40px',
    color: '#060606',
    fontFamily: 'Inter", sans-serif',
    textAlign: 'center'
  },
  radio: {
    fontWeight: 500,
    fontSize: '1.70em',
    marginTop: '5px',
    color: '#060606',
    fontFamily: 'Inter", sans-serif',
    display: "flex",
    justifyContent: "center"
  },
  textsig: {
    color: '#060606',
    fontFamily: '"Inter", sans-serif',
    wordBreak: "break-word"

  },
  textsig2: {
    color: '#060606',
    fontFamily: '"Inter", sans-serif',
    marginTop: 10

  },
  tierhorz: {

    borderLeft: '500px solid black',
    marginLeft: '103px',
    opacity: '0.1',
    marginRight: '80px',
    marginTop: "20px"

  },

  nexttier: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '16%',
    marginLeft: '550px'

  },
  backtier: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '16%',
    marginLeft: '120px'

  },
  formtxtsignature: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '35%'
  },
  formErrorsignature: {
    backgroundColor: '#ffd6d6',
    borderRadius: '5px 0px 0px 5px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '35%'
  },


}));
